
import SimpleHeader from "components/Headers/SimpleHeader.jsx";
import React from "react";
import {
  Button,
  Card,
  CardHeader, CardText,
  Col,
  Container,
  DropdownItem,
  DropdownMenu,
  DropdownToggle, Modal,
  Row,
  Table,
  UncontrolledDropdown,
} from "reactstrap";
import ReviewCompanyService from "../../../../services/reviewCompanyService";
import NotificationAlert from "react-notification-alert";
import ReactBSAlert from "react-bootstrap-sweetalert";
import ReviewContactService from "../../../../services/reviewContactService";
import _ from "lodash";
import FormInput from "../../../../components/common/form/FormInput";
import { CompanyPermissions, ContactPermissions, ContentPermissions } from "../../../../services/permissions";
import formatFrontendDate from "../../util/formatFrontendDate";
import Login from "../../auth/Login";
import UtilService from "../../../../services/utilService";
import Loader from "../../../Loader";
import AdminService from "../../../../services/adminService";
import CardFooter from "reactstrap/es/CardFooter";

class ReviewCompanyList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      filterName: null,
      filterCountry: null,
      filteredList: [],
      alert: null,
      contactModal: false,
      contactList: [],
      filteredContacts: [],
      massUploadModal: false,
      file: null,
      fileSelectUUID: UtilService.uuidv4(),
      loading: false,

    };
    this.delete = this.delete.bind(this);
    this.notify = this.notify.bind(this);
  }

  onChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  }

  fileChange = (event) => {
    this.setState({ file: event.target.files[0] })
  };


  componentDidMount() {
    ReviewCompanyService.list().then((response) => {
      this.setState({ list: response, filteredList: response });
    });
    ReviewContactService.list().then((response) => {
      this.setState({ contactList: response });
    });
  }

  hideDeleteAlert = () => {
    this.setState({
      alert: null
    });
  };

  confirmDeleteAlert = (uniqueId) => {
    this.setState({
      alert: (
        <ReactBSAlert
          warning
          style={{ display: "block" }}
          title="Are you sure?"
          onConfirm={() => this.delete(uniqueId)}
          onCancel={this.hideDeleteAlert}
          showCancel
          confirmBtnBsStyle="danger"
          confirmBtnText="Yes, delete it!"
          cancelBtnBsStyle="secondary"
          cancelBtnText="Cancel"
          btnSize=""
        >
          You won't be able to revert this!
        </ReactBSAlert>
      )
    });
  };

  toggleModal = state => {
    this.setState({
      [state]: !this.state[state]
    });
  };

  templateDownload = () => {
    let filename = "companyTemplate.xlsx"
    const link = document.createElement('a');
    link.href = `/${filename}`;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  massUpload = () => {
    this.setState({ loading: true })
    const data = new FormData()
    data.append('file', this.state.file)
    ReviewCompanyService.massUpload(data).then((response) => {
      console.log(response);
      this.toggleModal("massUploadModal");
      ReviewCompanyService.list().then((response) => {
        this.setState({ list: response, filteredList: response });
      });
      this.notify("success", "Mass Upload Successful", response);
      this.setState({ loading: false })
    }).catch((error) => {
      this.setState({ loading: false })
      this.toggleModal("massUploadModal");
      this.notify("danger", "Error", "Something went wrong!")
    });
  }

  applyFilter = () => {
    const { list, filterName, filterCountry } = this.state;

    const filteredList = _.filter(list, (company) => {
      const nameMatches = filterName ? _.includes(_.toLower(company.legalName), _.toLower(filterName)) : true;
      const countryMatches = filterCountry ? _.includes(_.toLower(company.country), _.toLower(filterCountry)) : true;

      return nameMatches && countryMatches;
    });

    this.setState({ filteredList: filteredList });
  }

  clearFilter = () => {
    this.setState({ filteredList: this.state.list, filterName: null, filterCountry: null })
  }

  displayContacts = (uniqueId) => {
    let filteredContacts = _.filter(this.state.contactList, value => value.company.uniqueId === uniqueId);
    this.setState({ filteredContacts: filteredContacts })
    this.toggleModal("contactModal");
  }

  delete(uniqueId) {
    this.setState({ alert: null })
    ReviewCompanyService.delete(uniqueId).then((response) => {
      this.notify(
        response.responseStatus.toLowerCase(),
        response.responseStatus,
        response.message
      );
      //TODO: TO be fixed with redux implementation
      //   this.props.history.push("/admin/dashboard");
      ReviewCompanyService.list().then((response) => {
        this.setState({ list: response, filteredList: response });
      });
    });
  }

  toggleModal = state => {
    this.setState({
      [state]: !this.state[state]
    });
  };

  notify = (type, title, message) => {
    let options = {
      place: "tc",
      message: (
        <div className="alert-text">
          <span className="alert-title" data-notify="title">
            {title}
          </span>
          <span data-notify="message">{message}</span>
        </div>
      ),
      type: type,
      icon: "ni ni-bell-55",
      autoDismiss: 5,
    };
    this.refs.notificationAlert.notificationAlert(options);
  };

  render() {
    let obj = this;
    return (
      <>
        <div className="rna-wrapper">
          <NotificationAlert ref="notificationAlert" />
        </div>
        <SimpleHeader
          name="List"
          parentName="Company"
          heading="XareGrwoth"
        // newBtnUrl="/admin/company/create"
        // newBtnText="Create Company"
        // style= {{display:CompanyPermissions.create()}}
        />
        {this.state.alert}
        {this.state.loading && <Loader />}
        <Container className="mt--6" fluid>
          <Row>
            <Col xl="12">
              <Card>
                <CardHeader className="border-0">
                  <Row className="align-items-center">
                    <Col xs={10}><h3 className="mb-0">Companies List</h3></Col>
                    <Col xs={2}>
                      <Modal
                        // size={"lg"}
                        className="modal-dialog-centered"
                        isOpen={this.state.massUploadModal}
                        toggle={() => this.toggleModal("massUploadModal")}
                      >

                        <div className="modal-header">
                          <h5 className="modal-title" id="contactUsModalLabel">
                            Mass Upload Data! Please upload an excel file to initiate mass upload.&nbsp;&nbsp;&nbsp;
                          </h5>
                          <button
                            aria-label="Close"
                            className="close"
                            data-dismiss="modal"
                            type="button"
                            onClick={() => this.toggleModal("massUploadModal")}
                          >
                            <span aria-hidden={true}>×</span>
                          </button>
                        </div>
                        <div className="modal-body">
                          <Row>
                            <Col md="9">
                              <FormInput
                                name="name"
                                className="form-control-label"
                                id="file"
                                placeholder="Excel Sheet"
                                type="file"
                                label="Excel Sheet"
                                onChange={this.fileChange}
                                multiple={false}
                                key={this.state.fileSelectUuid}
                              // errorMsg={this.props.errorObj.firstName || ""}
                              />
                            </Col>
                            <Col md="3">
                              <Button color="default" type="button" outline
                                onClick={this.massUpload} style={{ marginTop: "20px" }}
                              >
                                Upload
                              </Button>
                            </Col>
                          </Row>
                        </div>
                        <div className="modal-footer"
                          style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
                          <h5><strong>Instructions</strong></h5>
                          <ul style={{ textAlign: "left", paddingLeft: "20px", marginTop: "10px" }}>
                            <li>Columns in <span style={{ color: "red" }}>Red</span> are mandatory.</li>
                            <li>Column names must not be modified.</li>
                            <li>Sheet name must not be modified.</li>
                            <li>Values should not contain whitespaces at starting and end.</li>
                            <li>CompanyType must be a value only of the following - <strong>MANUFACTURER_BRAND, IMPORTER_DISTRIBUTOR,
                              TECH_SOLUTION_PROVIDER, ENGINEERING_SERVICES, SYSTEM_INTEGRATORS, CONSULTING_ADVISORY, HR_ACCOUNTING_LEGAL, ASSOCIATION</strong> {/* Example list */}</li>
                          </ul>
                          <Button size="md" color="default" type="button" outline onClick={this.templateDownload}
                            style={{ marginTop: "10px" }}>
                            Download Template
                          </Button>
                        </div>

                      </Modal>
                    </Col>
                  </Row>
                  <Row>
                    <p style={{ fontStyle: "italic", color: "gray" }}>
                      Use the filters below to narrow down your search results.
                    </p>
                  </Row>
                  <Row>

                    {/*<Col sm={2}>
                        <FormInput
                            name="dateFrom"
                            className="form-control-label"
                            id="date"
                            placeholder="inputPlaceHolder.meetingReport.date"
                            type="date"
                            onChange={this.onChange}
                            value={this.state.dateFrom || ""}
                            label="Date From"
                        />
                      </Col>
                      <Col sm={2}>
                        <FormInput
                            name="dateTo"
                            className="form-control-label"
                            id="date"
                            placeholder="inputPlaceHolder.meetingReport.date"
                            type="date"
                            onChange={this.onChange}
                            value={this.state.dateTo || ""}
                            label="Date To"
                        />
                      </Col>*/}
                    <Col md="2">
                      <FormInput
                        name="filterName"
                        className="form-control-label"
                        id="companyName"
                        placeholder="Company Name"
                        type="text"
                        onChange={this.onChange}
                        label="Company"
                        value={this.state?.filterName || ""}
                      // errorMsg={this.props.errorObj?.name || ""}
                      />
                    </Col>
                    <Col md="2">
                      <FormInput
                        name="filterCountry"
                        className="form-control-label"
                        id="countryName"
                        placeholder="Country Name"
                        type="text"
                        onChange={this.onChange}
                        label="Country"
                        value={this.state.filterCountry || ""}
                      // errorMsg={this.props.errorObj?.name || ""}
                      />
                    </Col>
                    <Col md={"2"}></Col>
                    <Col md={"2"}></Col>
                    <Col sm={4} style={{ marginTop: "30px" }}>
                      <Button size="md" outline color="default" type="button"
                        onClick={this.applyFilter}
                      >
                        Apply Filter
                      </Button>
                      <Button color="default" size="md" outline type="button"
                        onClick={this.clearFilter}>
                        Clear Filter
                      </Button>
                      <Button size="md" outline color="default" type="button"
                        onClick={() => this.toggleModal("massUploadModal")}
                      >
                        Mass Upload
                      </Button>
                    </Col>
                  </Row>
                </CardHeader>
                <Table className="align-items-center table-flush" responsive>
                  <thead className="thead-light">
                    <tr>
                      <th className="sort" data-sort="name" scope="col">
                        #
                      </th>
                      <th scope="col" />
                      <th className="sort" data-sort="budget" scope="col">
                        Date Created
                      </th>
                      <th className="sort" data-sort="status" scope="col">
                        Legal Name
                      </th>
                      <th className="sort" data-sort="status" scope="col">
                        Country
                      </th>
                      <th className="sort" data-sort="status" scope="col">
                        Website
                      </th>
                      <th className="sort" data-sort="status" scope="col">
                        Company Types
                      </th>
                      <th className="sort" data-sort="status" scope="col">
                        Last Report Created
                      </th>

                    </tr>
                  </thead>
                  <tbody className="list">
                    {this.state.filteredList.map(function (value, index) {
                      return (
                        <tr key={index}>
                          <td className="budget">{index + 1}</td>
                          <td className="text-right">
                            <UncontrolledDropdown>
                              <DropdownToggle
                                color=""
                                size="sm"
                                className="btn-icon-only text-light"
                              >
                                <i className="fas fa-ellipsis-v" />
                              </DropdownToggle>
                              <DropdownMenu
                                className="dropdown-menu-arrow"
                                right container="body"
                              >
                                {/*<DropdownItem
                                      style= {{display:ContactPermissions.read()}}
                                      onClick={(e) => {
                                        e.preventDefault();
                                        obj.displayContacts(value.uniqueId);
                                      }}
                                  >
                                    View All Contacts
                                  </DropdownItem>
                                  <DropdownItem
                                      onClick={(e) => {
                                        e.preventDefault();
                                        obj.props.history.push(
                                            `/admin/contact/create/${value.uniqueId}`
                                        );
                                      }}
                                  >
                                    Create Contact
                                  </DropdownItem>
                                  <DropdownItem
                                      onClick={(e) => {
                                        e.preventDefault();
                                        obj.props.history.push(
                                            `/admin/meetingReport/create/${value.uniqueId}`
                                        );
                                      }}
                                  >
                                    Create Report
                                  </DropdownItem>
                                  <DropdownItem
                                      onClick={(e) => {
                                        e.preventDefault();
                                        obj.props.history.push(
                                            `/admin/summary/${value.uniqueId}`
                                        );
                                      }}
                                  >
                                    All summaries
                                  </DropdownItem>*/}
                                <DropdownItem
                                  // style= {{display:CompanyPermissions.read(value?.createdBy)}}
                                  onClick={(e) => {
                                    e.preventDefault();
                                    obj.props.history.push(
                                      `/user/company/show/${value.uniqueId}`
                                    );
                                  }}
                                >
                                  Details
                                </DropdownItem>
                                <DropdownItem
                                  onClick={(e) => {
                                    e.preventDefault();
                                    obj.props.history.push(
                                      `/crm/meetingReport/create/${value.uniqueId}`
                                    );
                                  }}
                                >
                                  Create Report
                                </DropdownItem>
                                <DropdownItem
                                  // style= {{display:CompanyPermissions.update(value?.createdBy)}}
                                  onClick={(e) => {
                                    e.preventDefault();
                                    obj.props.history.push(
                                      `/user/company/edit/${value.uniqueId}`
                                    );
                                  }}
                                >
                                  Edit
                                </DropdownItem>
                                <DropdownItem
                                  // style= {{display:CompanyPermissions.delete()}}
                                  onClick={(e) => {
                                    e.preventDefault();
                                    obj.confirmDeleteAlert(`${value.uniqueId}`);
                                  }}
                                >
                                  Delete
                                </DropdownItem>
                              </DropdownMenu>
                            </UncontrolledDropdown>
                          </td>
                          <td className="budget">{formatFrontendDate(value.dateCreated)}</td>
                          <td className="budget">{value.legalName}</td>
                          <td className="budget">{value.country}</td>
                          <td className="budget">{value.website}</td>
                          <td className="budget">{value.companyTypeList && value.companyTypeList.map(function (type, index) {
                            return <h4 key={index} className="badge badge-lg badge-primary">{type}</h4>
                          })}</td>
                          <td className="budget">{value.latestReportDate ? formatFrontendDate(value.latestReportDate) : 'N/A'}</td>

                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </Card>
            </Col>
          </Row>

          <Modal
            className="modal-dialog-centered modal-lg"
            isOpen={this.state.contactModal}
            toggle={() => this.toggleModal("contactModal")}
          >
            <div className="modal-header">
              <h6 className="modal-title" id="modal-title-default">
                Contacts
              </h6>
              <button
                aria-label="Close"
                className="close"
                data-dismiss="modal"
                type="button"
                onClick={() => this.toggleModal("contactModal")}
              >
                <span aria-hidden={true}>×</span>
              </button>
            </div>
            <div className="modal-body">
              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th className="sort" data-sort="name" scope="col">
                      #
                    </th>
                    <th className="sort" data-sort="status" scope="col">
                      Full Name
                    </th>
                    <th className="sort" data-sort="status" scope="col">
                      Company Name
                    </th>
                    <th className="sort" data-sort="status" scope="col">
                      Contact Role
                    </th>
                    <th className="sort" data-sort="status" scope="col">
                      Email Address
                    </th>
                    <th className="sort" data-sort="status" scope="col">
                      Contact Number
                    </th>
                    <th scope="col" />
                  </tr>
                </thead>
                <tbody className="list">
                  {this.state.filteredContacts.map(function (value, index) {
                    return (
                      <tr key={index}>
                        <td className="budget">{index + 1}</td>
                        <td className="budget">{value.fullName}</td>
                        <td className="budget">{value.company.legalName}</td>
                        <td className="budget">{value.contactRole}</td>
                        <td className="budget">{value.email || "N/A"}</td>
                        <td className="budget">{value.number || "N/A"}</td>
                        <td className="text-right">
                          <UncontrolledDropdown>
                            <DropdownToggle
                              color=""
                              size="sm"
                              className="btn-icon-only text-light"
                            >
                              <i className="fas fa-ellipsis-v" />
                            </DropdownToggle>
                            <DropdownMenu
                              className="dropdown-menu-arrow"
                              right container="body"
                            >
                              <DropdownItem
                                onClick={(e) => {
                                  e.preventDefault();
                                  obj.props.history.push(
                                    `/admin/contact/show/${value.uniqueId}`
                                  );
                                }}
                              >
                                Details
                              </DropdownItem>
                              <DropdownItem
                                onClick={(e) => {
                                  e.preventDefault();
                                  obj.props.history.push(
                                    `/admin/contact/edit/${value.uniqueId}`
                                  );
                                }}
                              >
                                Edit
                              </DropdownItem>
                              <DropdownItem
                                onClick={(e) => {
                                  e.preventDefault();
                                  obj.confirmDeleteAlert(`${value.uniqueId}`);
                                }}
                              >
                                Delete
                              </DropdownItem>
                            </DropdownMenu>
                          </UncontrolledDropdown>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </div>
            <div className="modal-footer">
              <Button
                className="ml-auto"
                color="link"
                data-dismiss="modal"
                type="button"
                onClick={() => this.toggleModal("contactModal")}
              >
                Close
              </Button>
            </div>
          </Modal>
        </Container>
      </>
    );
  }
}

export default ReviewCompanyList;
